import { Account, IWeb3Type, OutputDef } from '../types/types';

const outputDef: OutputDef = {
  config: {
    accounts: {
      eth: {
        address: '',
        alliance: 'evm',
        name: '',
        chainId: undefined,
        symbol: '',
      },
    },
  },
  hash: '',
  salt: '',
  signature: '',
  id: '',
  method: '',
  params: [],
  result: [],
  options: {
    account: {
      address: '',
      alliance: 'evm',
      name: '',
      chainId: undefined,
      symbol: '',
      chainKey: '',
      chainName: '',
      chainSymbol: '',
    },
    metaData: {
      hostname: '',
      icon: '',
      name: '',
      url: '',
    },
  },
};
export const loginDefineProperties = (
  request: any,
  response: any,
  chain: IWeb3Type = 'EVM',
  isTonProof = false
) => {
  const output = { ...outputDef }; //keep deep link
  output.hash = request.hash;
  output.salt = request.salt;
  output.signature = request.signature;
  output.id = request.id;
  output.method = request.method;
  output.params = request.params;
  if (response.code === 10000) {
    if (chain === 'EVM') {
      output.config.accounts = {
        eth: {
          address:
            response.result.defaultEthereumAddress ?? response.result.v2Address,
          alliance: 'evm',
          name: 'ethereum',
          chainId: 1,
          symbol: 'ETH',
        },
      };
    } else {
      const res = isTonProof ? response.result.user : response.result;
      output.config.accounts = formatAccount(
        chain,
        res,
        request.params?.[0]?.chainId
      );
    }

    output.result =
      chain === 'EVM'
        ? [response.result.defaultEthereumAddress ?? response.result.v2Address]
        : output.config.accounts[chain.toLowerCase()];

    if (isTonProof) {
      output.result.tonProof = response.result.tonProof;
      output.result.stateInit = response.result.stateInit;
    }
  } else {
    throw new Error(JSON.stringify(response));
  }
  output.options.account =
    output.config.accounts[chain === 'EVM' ? 'eth' : chain.toLowerCase()];
  return output;
};

export const signDefineProperties = (
  request: any,
  response: any,
  source: any,
  chain: IWeb3Type = 'EVM'
) => {
  const output = { ...outputDef };
  if (chain === 'EVM') {
    output.config.accounts = {
      eth: source,
    };
  } else {
    output.config.accounts = {
      [chain.toLowerCase()]: source,
    };
  }
  output.hash = request.hash;
  output.salt = request.salt;
  output.signature = request.signature;
  output.id = request.id;
  output.method = request.method;
  output.params = request.params;
  output.result = response ?? {
    code: -1,
    message: 'Network error',
    result: undefined,
  };
  output.options.account =
    output.config.accounts[chain === 'EVM' ? 'eth' : chain.toLowerCase()];
  return output;
};

export const formatAccount = (
  chain: IWeb3Type,
  res = {
    defaultEthereumAddress: '',
    v2Address: '',
    defaultBtcAddress: '',
    solanaAddress: '',
    tonAddress: '',
    tonAddressTest: '',
    tonPublicKey: '',
    suiAddress: '',
  },
  chainId
): Record<string, Account> => {
  switch (chain) {
    case 'BTC':
      return {
        btc: {
          address: res.defaultBtcAddress,
          alliance: 'btc',
          name: 'bitcoin',
          chainId: chainId || 0,
          symbol: 'BTC',
        },
      };
    case 'SOL':
      return {
        sol: {
          address: res.solanaAddress,
          alliance: 'sol',
          name: 'solana',
          chainId: chainId || 501,
          symbol: 'SOL',
        },
      };
    case 'TON':
      return {
        ton: {
          // TODO: testnet address need to be changed
          address: chainId === 1101 ? res.tonAddressTest : res.tonAddress,
          publicKey: res.tonPublicKey,
          alliance: 'ton',
          name: 'ton',
          chainId: chainId || 1100,
          symbol: 'TON',
        },
      };
    case 'SUI':
      return {
        sui: {
          address: res.suiAddress,
          alliance: 'sui',
          name: 'sui',
          chainId: chainId || 784,
          symbol: 'SUI',
        },
      };
    default:
      return {
        eth: {
          address: res.defaultEthereumAddress ?? res.v2Address,
          alliance: 'evm',
          name: 'ethereum',
          chainId: 1,
          symbol: 'ETH',
        },
      };
  }
};
